import React from "react";
import styles from "./FullProfile.module.css";

export default function WorkExperience({ data }) {
  return (
    <>
      <h4>Work Experience Summary</h4>
      <p>
        {data &&
          data.workingSummary &&
          data.workingSummary.split("\n").map((line, idx) => (
            <React.Fragment key={idx}>
              {line}
              <br />
            </React.Fragment>
          ))}
      </p>
      
        {data?.workingExperience.map((item) => (
          <div className={styles.companyProfile} key={item.companyName}>
            
            <div className={styles.companyName}> {item.companyName}  </div>
            <div className={styles.designation}> {item.designation} | <div className={styles.duration}>{item.duration}</div></div>
            <div className={styles.description}>{item.description}</div>
           
          </div>
        ))}
    </>
  );
}
